import Cookies from 'js-cookie'

// export const namespaced = true

let initialPagination = {
    pageSize:20,
    current: 1
}

const state = {
	catalog: Cookies.getJSON('catalog'),
	order: Cookies.getJSON('order'),
	customer: Cookies.getJSON('customer'),
	poultry: Cookies.getJSON('poultry'),
	subCustomer: Cookies.getJSON('subCustomer'),
	saleTransaction: Cookies.getJSON('saleTransaction'),
	quickActionCount: localStorage.getItem('quickActionCount'),
	preViewInfo: localStorage.getItem('preViewInfo'),
	invoiceInfo: localStorage.getItem('invoiceInfo'),
	preViewData: localStorage.getItem('preViewData'),
	replenishData: localStorage.getItem('replenishData'),
	backOrdersData: localStorage.getItem('backOrdersData'),
	productGroupInfo: Cookies.getJSON('productGroupInfo'),
	reportDetails: Cookies.getJSON('reportDetails'),
	purchaseOrdersDetails: Cookies.getJSON('purchaseOrdersDetails'),
	productDetailsInfo: Cookies.getJSON('productDetailsInfo'),
	wareHouseInfo: Cookies.getJSON('wareHouseInfo') || {},
	wareHouseDeliveryLinesInfo:
		Cookies.getJSON('wareHouseDeliveryLinesInfo') || {},
	wareHouseTransferLinesInfo:
		Cookies.getJSON('wareHouseTransferLinesInfo') || {},
	pagination:
		Cookies.getJSON('pagination') === null ||
		Cookies.getJSON('pagination') === undefined
			? initialPagination
			: Cookies.getJSON('pagination'),
	backOrder: Cookies.getJSON('backOrder'),
	salesType: Cookies.get('salesType') || 'item',
};


const getters = {
	getCatalog: (state) => {
		return state.catalog;
	},
	getSalesType: (state) => {
		return state.salesType;
	},
	getQuickActionCount: (state) => {
		return state.quickActionCount;
	},
	getOrder: (state) => {
		return state.order;
	},
	getCustomer: (state) => {
		return state.customer;
	},
	getPoultry: (state) => {
		return state.poultry;
	},
	getSubCustomer: (state) => {
		return state.subCustomer;
	},
	getSaleTransaction: (state) => {
		return state.saleTransaction;
	},
	getPagination: (state) => {
		return state.pagination;
	},
	getPreViewInfo: (state) => {
		return state.preViewInfo;
	},
	getPreViewData: (state) => {
		return state.preViewData;
	},
	getProductGroupInfo: (state) => {
		return state.productGroupInfo;
	},
	getProductDetailsInfo: (state) => {
		return state.productDetailsInfo;
	},
	getReportDetails: (state) => {
		return state.reportDetails;
	},
	getBackOrder: (state) => {
		return state.backOrder;
	},
	getWareHouseInfo: (state) => {
		return state.wareHouseInfo;
	},
	getWareHouseDeliveryLinesInfo: (state) => {
		return state.wareHouseDeliveryLinesInfo;
	},
	getWareHouseTransferLinesInfo: (state) => {
		return state.wareHouseTransferLinesInfo;
	},
	getPurchaseOrdersDetails: (state) => {
		return state.purchaseOrdersDetails;
	},
	getReplenishData: (state) => {
		return state.replenishData;
	},
	getBackOrdersData: (state) => {
		return state.backOrdersData;
	},
	getInvoiceInfo: (state) => {
		return state.invoiceInfo;
	}
	
};

const actions = {
	setCatalogInfo({ commit }, catalog) {
		commit('setCatalog', catalog);
		Cookies.set('catalog', catalog, { expires: 1 / 48 }); // Expires 30mins
	},
	setBackOrderInfo({ commit }, backOrder) {
		commit('setBackOrder', backOrder);
		Cookies.set('backOrder', backOrder, { expires: 1 / 48 }); // Expires 30mins
	},
	setReportDetailsInfo({ commit }, reportDetails) {
		commit('setReportDetails', reportDetails);
		Cookies.set('reportDetails', reportDetails, { expires: 1 / 48 }); // Expires 30mins
	},

	setPreviewInfo({ commit }, preview) {
		commit('setPreview', preview);
		localStorage.setItem('preViewInfo', preview); // Expires 30mins
	},

	setReplenishDataInfo({ commit }, replenishData) {
		commit('setReplenish', replenishData);
		localStorage.setItem('replenishData', replenishData); // Expires 30mins
	},

	setInvoiceInfo({ commit }, invoiceInfo) {
		commit('setInvoice', invoiceInfo);
		localStorage.setItem('invoiceInfo', invoiceInfo); // Expires 30mins
	},

	setBackOrderDataInfo({ commit }, backOrdersData) {
		commit('setBackOrdersData', backOrdersData);
		localStorage.setItem('backOrdersData', backOrdersData); // Expires 30mins
	},

	setOrderInfo({ commit }, order) {
		commit('setOrder', order);
		Cookies.set('order', order, { expires: 1 / 48 }); // Expires 30mins
	},
	setCustomerInfo({ commit }, customer) {
		commit('setCustomer', customer);
		Cookies.set('customer', customer, { expires: 1 / 48 }); // Expires 30mins
	},
	setSubCustomerInfo({ commit }, subCustomer) {
		commit('setSubCustomer', subCustomer);
		Cookies.set('subCustomer', subCustomer, { expires: 1 / 48 }); // Expires 30mins
	},
	setPoultryInfo({ commit }, poultry) {
		commit('setPoultry', poultry);
		Cookies.set('poultry', poultry, { expires: 1 / 48 }); // Expires 30mins
	},
	setSaleTransactionInfo({ commit }, saleTransaction) {
		commit('setSaleTransaction', saleTransaction);
		Cookies.set('saleTransaction', saleTransaction, { expires: 1 / 48 }); // Expires 30mins
	},
	setPaginationInfo({ commit }, pagination) {
		commit('setPagination', pagination);
		Cookies.set('pagination', pagination, { expires: 1 / 48 }); // Expires 30mins
	},

	setProductGroupInfo({ commit }, productGroupInfo) {
		commit('setProductGroup', productGroupInfo);
		Cookies.set('productGroupInfo', productGroupInfo, { expires: 1 / 48 }); // Expires 30mins
	},
	setProductDetailsInfo({ commit }, productDetailsInfo) {
		commit('setProductDetails', productDetailsInfo);
		Cookies.set('productDetailsInfo', productDetailsInfo, { expires: 1 / 48 }); // Expires 30mins
	},
	setQuickActionInfo({ commit }, quickActionCount) {
		commit('setQuickAction', quickActionCount);
		// Cookies.set('quickActionCount', quickActionCount, { expires: 1 });
		localStorage.setItem('quickActionCount', quickActionCount);
	},
	setPreviewDataInfo({ commit }, preViewData) {
		commit('setPreviewData', preViewData);
		// Cookies.set('preViewData', JSON.stringify(preViewData), { expires: 1 });
		localStorage.setItem('preViewData', preViewData);
	},

	setSalesTypeInfo({ commit }, salesType) {
		commit('setSalesType', salesType);
		Cookies.set('salesType', salesType, { expires: 1 / 48 }); // Expires 30mins
	},

	setWareHouseInfo({ commit }, wareHouseInfo) {
		commit('setWareHouseInfo', wareHouseInfo);
		Cookies.set('wareHouseInfo', wareHouseInfo, { expires: 1 }); // Expires 1 day
	},

	setPurchaseOrdersInfo({ commit }, purchaseOrdersDetails) {
		commit('setPurchaseOrdersDetails', purchaseOrdersDetails);
		Cookies.set('purchaseOrdersDetails', purchaseOrdersDetails, { expires: 1 }); // Expires 1 day
	},

	setWareHouseDeliveryLinesInfo({ commit }, wareHouseDeliveryLinesInfo) {
		commit('setWareHouseDeliveryLinesInfo', wareHouseDeliveryLinesInfo);
		Cookies.set('wareHouseDeliveryLinesInfo', wareHouseDeliveryLinesInfo, {
			expires: 1,
		}); // Expires 1 day
	},
	setWareHouseTransferLinesInfo({ commit }, wareHouseTransferLinesInfo) {
		commit('setWareHouseTransferLinesInfo', wareHouseTransferLinesInfo);
		Cookies.set('wareHouseTransferLinesInfo', wareHouseTransferLinesInfo, {
			expires: 1,
		}); // Expires 1 day
	},

	resetAddProductSetup() {
		Cookies.remove('productGroupInfo'), Cookies.remove('productDetailsInfo');
	},
};

 const mutations = {
		setCatalog: (state, catalog) => {
			state.catalog = catalog;
		},
		setSalesType: (state, salesType) => {
			state.salesType = salesType;
		},
		setBackOrder: (state, backOrder) => {
			state.backOrder = backOrder;
		},
		setReportDetails: (state, reportDetails) => {
			state.reportDetails = reportDetails;
		},
		setOrder: (state, order) => {
			state.order = order;
		},
		setCustomer: (state, customer) => {
			state.customer = customer;
		},
		setSubCustomer: (state, subCustomer) => {
			state.subCustomer = subCustomer;
		},
		setPoultry: (state, poultry) => {
			state.poultry = poultry;
		},
		setSaleTransaction: (state, saleTransaction) => {
			state.saleTransaction = saleTransaction;
		},
		setPagination: (state, pagination) => {
			state.pagination = pagination;
		},
		setPreview: (state, preview) => {
			state.preViewInfo = preview;
		},
		setProductGroup: (state, productGroupInfo) => {
			state.productGroupInfo = productGroupInfo;
		},
		setProductDetails: (state, productDetailsInfo) => {
			state.productDetailsInfo = productDetailsInfo;
		},
		setQuickAction: (state, quickActionCount) => {
			state.quickActionCount = quickActionCount;
		},
		setPreviewData: (state, preViewData) => {
			state.preViewData = preViewData;
		},
		setWareHouseInfo: (state, wareHouseInfo) => {
			state.wareHouseInfo = wareHouseInfo;
		},
		setWareHouseDeliveryLinesInfo: (state, wareHouseDeliveryLinesInfo) => {
			state.wareHouseDeliveryLinesInfo = wareHouseDeliveryLinesInfo;
		},
		setWareHouseTransferLinesInfo: (state, wareHouseTransferLinesInfo) => {
			state.wareHouseTransferLinesInfo = wareHouseTransferLinesInfo;
		},
		setPurchaseOrdersDetails: (state, purchaseOrdersDetails) => {
			state.purchaseOrdersDetails = purchaseOrdersDetails;
		},
		setReplenish: (state, replenishData) => {
			state.replenishData = replenishData;
		},
		setBackOrdersData: (state, backOrdersData) => {
			state.backOrdersData = backOrdersData;
		},

		setInvoice: (state, invoiceInfo) => {
			state.invoiceInfo = invoiceInfo;
		},
 };

 export default{
    state,
    getters,
    actions,
    mutations
}